import { useQuery } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { ApiUserElFindOneParams } from '@/apis/swaggers/v2/v2-swagger'
import { QUERY_KEY } from '@/apis/swaggers/swagger-docs'
import { QueryComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'

type QueryParams = QueryComposableParams<ApiUserElFindOneParams, unknown>

const fetchUserOne = async (params: ApiUserElFindOneParams) => {
  const { data } = await apiClient.v2.apiUserElFindOne(params);
  return checkApiResponse(data);
}

export const userKeys = {
  all: [QUERY_KEY.v2apiUserElFindOne] as const,
  list: (params: ApiUserElFindOneParams) => [...userKeys.all, params] as const,
}

/** 명령형(await) 호출용 쿼리 정의 — `queryClient.fetchQuery(userFindOneQueryOptions(params))` */
export const userFindOneQueryOptions = (params: ApiUserElFindOneParams) => ({
  queryKey: userKeys.list(params),
  queryFn: () => fetchUserOne(params),
})

export const useUserFindOneQuery = ({ params, options }: QueryParams) => {
  return useQuery(() => ({
    queryKey: userKeys.list(resolveMaybeGetter(params)),
    queryFn: () => fetchUserOne(resolveMaybeGetter(params)),
    ...resolveMaybeGetter(options ?? {}),
  }))
}
